import React from "react";
import { Button } from "@mui/material";

/**
 * Reusable outlined cancel button with consistent readable styling.
 */
const CancelButton = React.forwardRef(function CancelButton(props, ref) {
  const { children = "Cancel", sx, ...rest } = props;
  return (
    <Button
      ref={ref}
      variant="outlined"
      {...rest}
      sx={{
        minWidth: 120,
        color: "text.primary",
        borderColor: "rgba(0, 0, 0, 0.2)",
        fontWeight: 500,
        "&:hover": {
          borderColor: "text.primary",
          backgroundColor: "rgba(0,0,0,0.04)",
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  );
});

export default CancelButton;
